import { render, staticRenderFns } from "./ComentariosCuentaCobro.vue?vue&type=template&id=cc7cec60&scoped=true"
import script from "./ComentariosCuentaCobro.vue?vue&type=script&lang=js"
export * from "./ComentariosCuentaCobro.vue?vue&type=script&lang=js"
import style0 from "./ComentariosCuentaCobro.vue?vue&type=style&index=0&id=cc7cec60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7cec60",
  null
  
)

export default component.exports